export const expenseAr = {
  "Donner un note": "إعط ملاحظة",
  "Donner le montant": "أعط المبلغ",
  "jour": "يوم",
  "mois": "شهر",
}
